namespace Umbrella.Chat {
    export interface ChatConversationHistoryModalScope extends IPopupScope {
        conversationId: System.Guid;
    }

    @Controller('Chat', 'ChatConversationHistoryModalController')
    export class ChatConversationHistoryModalController {}
}
